import { settingsApiRequest } from '../../screens/settings/settingsApi';

const handler = async (args, { rejectWithValue }) => {
  try {
    const data = await settingsApiRequest({ method: 'GET', path: '/settings/media-guides' });
    if (process.env.NODE_ENV !== 'production') {
      console.log('services.mediaguides.getMediaGuides@handler', 'fetched:', data?.mediaGuides?.length);
    }
    return { mediaGuides: data.mediaGuides || [] };
  } catch (error) {
    console.error('services.mediaguides.getMediaGuides@handler', error);
    return rejectWithValue(error.message || error);
  }
};

const pending = (state) => ({ ...state, loading: true });
const fulfilled = (state, action) => ({
  ...state,
  loading: false,
  lists: action.payload.mediaGuides,
  initialized: true,
});
const rejected = (state) => ({ ...state, loading: false });

export default { handler, pending, fulfilled, rejected };
